// Globale Styles und Skripte, die auf allen Seiten zur Verfügung stehen müssen.
// Wird in jedem Page-Layout-Modul importiert.
import '../../../project.scss';

import './globals/simplebar';

import '../js/src/vendor/script/opacc.general.js';
import '../js/src/vendor/script/opacc.navigation.js';
import '../js/src/vendor/script/opacc.staticcontent.js';
import '../js/src/vendor/script/opacc.media.js';
import '../js/src/vendor/script/opacc.favorite.js';
import '../js/src/vendor/script/opacc.form.js';
import '../js/src/vendor/script/opacc.verification.js';

import '../js/src/sw.manager';
import '../js/src/custom.basket';
import '../js/src/custom.directsearchsuggest';
import '../js/src/project';
